// extracted by mini-css-extract-plugin
module.exports = {"container":"OnboardingBanner_container_2FMn4","icon":"OnboardingBanner_icon_2aKEm","message":"OnboardingBanner_message_2GbfS","actions":"OnboardingBanner_actions_2OIDj"};